export default defineAppConfig({
  ui: {
    colors: {
      primary: process.env.NUXT_PUBLIC_PRIMARY_COLOR || 'purple',
      neutral: 'slate'
    }
  }
})
